import { computed } from "vue";
import store from "@/store";

const getEventYears = eventYear => {
  const year = Number(eventYear);
  if (!/^\d{4}$/.test(String(eventYear)) || year < 2022) return [];
  return Array.from({ length: year - 2022 + 1 }, (_, index) =>
    String(year - index)
  );
};

const useEventYears = () =>
  computed(() => getEventYears(store.getters["main/appYear"]));

export { getEventYears, useEventYears };
